import { defineStore } from 'pinia'

import axios from 'axios'

export const useEmployeeSearchStore = defineStore('employeeSearch', {
  state: () => ({
    filters: {
      company_name: '',
      department_name: '',
      first_name: '',
      last_name: '',
      tag_slug: '',
    },
    page: 1,
    limit: 10,     // <-- centralized
    total: 0,      // <-- centralized
    results: [] as Array<{ employee_id: number, 
      first_name: string, 
      last_name: string }>,
  }),
  actions: {
    setFilters(newFilters: any) {
      this.filters = { ...this.filters, ...newFilters }
    },
    setPage(p: number) { this.page = p },
    setLimit(l: number) { this.limit = l },
    setTotal(t: number) { this.total = t },
    setResults(res: any[]) { this.results = res },

    // NEW: fetch any page using current filters
    async fetchPage(p?: number) {
      const page = p ?? this.page
      const params: any = {
        offset: (page - 1) * this.limit,
        limit: this.limit,
        ...this.filters,
      }
      if (this.filters.tag_slug) {
        params.tag = this.filters.tag_slug
      } else {
        delete params.tag
      }
      delete params.tag_slug
      const { data } = await axios.get('/api/employees', { params })
      this.total = data.total || 0
      this.results = data.employees || []
      this.page = page
    },
  },
  getters: {
    employeeIds: (state) => state.results.map(e => e.employee_id),
    totalPages: (state) => Math.max(1, Math.ceil(state.total / state.limit)),
  },
})
